<template>
  <div>
    <pageTable />
  </div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'tc-fabricSell',
  components: {
    PageTable,
  },
}
</script>
